import { CliError, ExitCode } from '../../../lib/errors';
import type { OutputFormat } from '../../../lib/output';

/**
 * 企業職缺寫入命令共用的 resolved context 子集。
 * 寫入命令目前不使用 `color`（輸出非表格著色），故不納入。
 */
export interface WriteCtx {
	baseUrl: string;
	locale: string;
	timeoutMs: number;
	format: OutputFormat;
}

/** enc_id 去空白 + 非空檢查（空字串 → exit 2、不發請求）。 */
export function requireEncId(encId: string): string {
	const trimmed = encId.trim();
	if (!trimmed) throw new CliError('enc_id must not be empty', ExitCode.InvalidArgument);
	return trimmed;
}
